<!-- =========================================================================================
    File Name: Error404.vue
    Description: 404 Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center background"
    v-bind:style="{ 'background-image': 'url(' + imagenFondo + ') !important' }"
  >
    <div
      :class="`vx-col flex items-center justify-center
        flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center`"
    >
      <img src="@/assets/images/pages/404.png" alt="graphic-404" class="mx-auto mb-4 max-w-full">
      <h1 class="sm:mx-0 mx-4 mb-12 text-5xl d-theme-heading-color info">404 - Página no
        encontrada!</h1>
      <vs-button size="large" to="/">Ir al Inicio</vs-button>
    </div>
  </div>
</template>
<script>

import I18nMixin from '@/febos/global/_vue/mixins/I18nMixin';
import PersonalizacionMixin from '@/febos/global/empresas/mixins/PersonalizacionMixin';

export default {
  mixins: [I18nMixin, PersonalizacionMixin],
  data() {
    return {};
  }
};
</script>
<style scoped>
.info {
  color: #ffffff;
  padding: 30px;
  margin-top: 30px;
  text-shadow: 0 0 30px #000000;
}
.background{
  background-size: cover !important;
}
</style>
